import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PaginationService {

    private activatedRoute = inject(ActivatedRoute);

    rowsPerPageOptions = [10, 20, 50, 70, 100];

    private queryParams = toSignal(
        this.activatedRoute.queryParamMap,
        { initialValue: this.activatedRoute.snapshot.queryParamMap }
    );

    currentPage = computed(() => {
        const value = this.queryParams().get('page');
        const page = value ? +value : 1;
        return isNaN(page) ? 1 : page;
    });

    rows = computed(() => {
        const value = this.queryParams().get('per_page');
        const rows = value ? +value : 10;
        return this.rowsPerPageOptions.includes(rows) ? rows : 10;
    });

    getCurrentPage(prefix: string) {
        return computed(() => {
            const value = this.queryParams().get(`${prefix}_page`);
            const page = value ? +value : 1;
            return isNaN(page) ? 1 : page;
        });
    }

    getRows(prefix: string) {
        return computed(() => {
            const value = this.queryParams().get(`${prefix}_per_page`);
            const rows = value ? +value : 10;
            return this.rowsPerPageOptions.includes(rows) ? rows : 10;
        });
    }
}
